import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from '@/shared/components/layout/AppLayout';
import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';
import { AuthPage } from '@/features/auth/AuthPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { FramesToOrderPage } from '@/features/frames-to-order/FramesToOrderPage';
import { WeeklyOrderingPage } from '@/features/weekly-ordering/WeeklyOrderingPage';
import { ReceivingPage } from '@/features/receiving/ReceivingPage';
import { ReportsPage } from '@/features/reports/ReportsPage';
import { AdminPage } from '@/features/admin/AdminPage';
import { SmsOptInPublicPage } from '@/features/settings/components/SmsOptInPublicPage';
export function AppRouter() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<AuthPage />} />
      <Route path="/sms-opt-in" element={<SmsOptInPublicPage />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="frames-to-order" element={<FramesToOrderPage />} />
        <Route path="weekly-ordering" element={<WeeklyOrderingPage />} />
        <Route path="receiving" element={<ReceivingPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="settings" element={<Navigate to="/admin?tab=per-location" replace />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
